import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table";
import { selectVariantsListItems } from "../../../../../redux/variants/selector";
import { variants } from "../../../../../redux/variants/action";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../components/PageLoader";


const ManagementVariants = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const itemsData = useSelector(selectVariantsListItems)
    const [pageSize, setPageSize] = useState(10);
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name', sortable: true, filter: true },
      { field: 'Price', headerName: 'Price', filter: true, sortable: true, isCurrencyValueFormat: true },
      { field: 'IsAvailable', headerName: 'Available',cellRenderer: 'yesNoRenderer' },
      { field: 'Description', headerName: 'Description', sortable: true, filter: true  },
      { field: 'CreatedOnUtc', headerName: 'CreatedOn',isDateValueFormat:true },
      { field: 'ModifiedOnUtc', headerName: 'ModifiedOn' ,isDateValueFormat:true},
        ]);
      }

      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      const handleDelete=(data: any)=>{
        dispatch(variants.delete({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/variants/delete`,
          entity: 'variants',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
        dispatch(variants.list({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/variants/list`,entity:'variants',jsonData:{
          "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }
      const additionButtons: any = [
        {
          name: 'Add Variants',
          callback: () => handleAdd(),
        }
      ];

      const fetchVariants=()=>{
        dispatch(variants.list({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/variants/list`,entity:'variants',jsonData:{
           "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",}
      }));
      }

	useEffect(() => {
        createColumnDefs()
        fetchVariants()
	}, [pageData,pageSize])

	return (
  
    <>
    {itemsData?.isLoading ? <PageLoader />
: 
 <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
 paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Variants" />
}
 </>
	);

}
export default ManagementVariants;
